import { convertDate } from "./convertDate";
import { checkDueDateExpired } from "./checkDueDateExpired";
import { checkDebtWillExpireDays } from "./checkDebtWillExpireDays";
import { checkExpireToday } from "./checkExpireToday";

export const convertDebitsData = (item) => {
  item.DataReferenciaConvertida = convertDate(item.DataReferencia);
  item.DataVencimentoConvertida = convertDate(item.DataVencimento);

  item.DebitoAtrasado = checkDueDateExpired(item);
  item.DebitoVincendo = checkDebtWillExpireDays(item, 365);
  item.DebitoVenceHoje = checkExpireToday(item);

  item.CheckedDebt = false;

  if (item.Solicitacao !== null && item.Solicitacao !== undefined) {
    item.Solicitacao.DataAdesaoConvertida = convertDate(
      item.Solicitacao.DataAdesao
    );
  }
  if (item.DataSolicitacao !== null && item.DataSolicitacao !== undefined) {
    item.DataSolicitacao = convertDate(item.DataSolicitacao);
  }
  if (item.DataVencimento !== null && item.DataVencimento !== undefined) {
    item.DataVencimento = convertDate(item.DataVencimento);
  }

  if (item.ValorOriginal === null) {
    item.ValorOriginalVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorOriginal >= 0) {
    item.ValorOriginalVirgula = item.ValorOriginal.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  if (item.ValorCorrecao === null) {
    item.ValorCorrecaoVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorCorrecao >= 0) {
    item.ValorCorrecaoVirgula = item.ValorCorrecao.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  if (item.ValorMulta === null) {
    item.ValorMultaVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorMulta >= 0) {
    item.ValorMultaVirgula = item.ValorMulta.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  if (item.ValorMultaInfracao === null) {
    item.ValorMultaInfracaoVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorMultaInfracao >= 0) {
    item.ValorMultaInfracaoVirgula = item.ValorMultaInfracao.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  if (item.ValorJuros === null) {
    item.ValorJurosVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorJuros >= 0) {
    item.ValorJurosVirgula = item.ValorJuros.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  if (item.ValorHonorarios === null) {
    item.ValorHonorariosVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorHonorarios >= 0) {
    item.ValorHonorariosVirgula = item.ValorHonorarios.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  if (item.ValorDesconto === null) {
    item.ValorDescontoVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorDesconto >= 0) {
    item.ValorDescontoVirgula = item.ValorDesconto.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  if (item.ValorPagar === null) {
    item.ValorPagarVirgula = (0)
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else if (item.ValorPagar >= 0) {
    item.ValorPagarVirgula = item.ValorPagar.toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  
  if(item.DebitoVenceHoje === true && item.DebitoAtrasado === true){
    item.DebitoAtrasado = false;
  }

};
